import React, { useState, useEffect } from 'react';
import BackButton from '../../main/BackButton';
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import classes from "../css/Home.module.css";
import Line from "../../main/Line";
import SizeGuide from './SizeGuide/SizeGuide';
import axios from '../../../axios-backend';
import SizeFinder from './SizeFinder/SizeFinder'

const ProductSizeGuide = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    // All hooks must be called before any conditional returns
    const [showSizeFinder, setShowSizeFinder] = useState(false);
    const [showSizeGuide, setShowSizeGuide] = useState(false);
    const [sizeList, setSizeList] = useState([]);

    // Get state values safely
    const state = location.state || {};
    const { type, gender } = state;

    useEffect(() => {
        // Redirect if no state
        if (!location.state) {
            navigate('/');
            return;
        }

        // Only fetch sizes if we have type and gender
        if (type && gender) {
            axios.get(`/sizes-by-type`, { params: { 'tid': type, gender } }).then(data => {
                if (data.data.status === 200) {
                    if (data.data.list.length === 0) {
                        alert('sorry, no product');
                        navigate(-1);
                    }
                    else {
                        setSizeList(data.data.list)
                    }
                }
            });
        }
    }, [type, gender, location.state, navigate])

    // Early return if no state
    if (!location.state) {
        return null;
    }

    return (
        <>
            <BackButton />
            <Line type="bottom-line">
                <label className={classes.navLink} style={{ cursor: "pointer" }} onClick={() => { setShowSizeFinder(true); }}>
                    size finder
                </label>
            </Line>
            <Line type="bottom-line">
                <label className={classes.navLink} style={{ cursor: "pointer" }} onClick={() => { setShowSizeGuide(true); }}>
                    size guide
                </label>
            </Line>
            <Line type="bottom-line">
                <NavLink to="/products/measure" state={{ type, gender }} className={classes.navLink}>
                    How to measure
                </NavLink>
            </Line>
            <Line type="bottom-line">
                <NavLink to={"/products/questions"} className={classes.navLink}>
                    questions? contact us
                </NavLink>
            </Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <Line type="bottom-line"></Line>
            <SizeFinder show={showSizeFinder} gender={gender} tid={type} closeFun={() => {
                setShowSizeFinder(false);
            }} />
            <SizeGuide show={showSizeGuide} gender={gender} sizeList={sizeList} closeFun={() => {
                setShowSizeGuide(false)
            }} />
        </>
    )
}

export default ProductSizeGuide;


